import WujieVue from "wujie-vue3";
import { AppCollection } from "@/constant";
const { bus } = WujieVue;
type EventList =
  | "LOGIN_EXPIRED" /* 子应用登录失效 child => container */
  | "CHANGE_ROUTE" /* 改变子应用路由 container => child */
  | "OPEN_DETAIL_PAGE" /* 子应用打开独立的详情页（司机详情、车辆详情等） child => container */
  | "JUMP_DETAIL_PAGE" /* v3商车通知v2商车打开详情页，主应用做跳板 child => container */
  | "JUMP_LIST_PAGE" /* 子应用页面内跳转到另一个常规页面 */
  | "PREVIEW_MEDIA" /* 子应用发起预览多媒体资源请求 */
  | "SYNC_STATE" /* 子应用申请同步主应用的全局状态 */
  | "DISTRIBUTE_STATE" /* 主应用分发全局状态 */
  | "CLOSE_PAGE_TAB" /* 关闭子应用的tab页 */
  | "CLOSE_PAGE" /* 关闭子应用的页面 */
  | "PROBLEM_FEEDBACK" /*显示问题反馈弹框*/
  | "NOT_FOUND_PAGE" /*重定向到404页面*/
  | "POST_MESSAGE" /*应用通讯*/
  | "HASH_CHANGE" /*监听hash变化*/
  | "UPDATE_TAB_SUB_NAME" /* 子应用修改 tab 副标题 child => container */

type EventBusInstance = {
  $emit: (e: EventList, params: Record<string, any>) => void;
  $on: (e: EventList, fn: (...args: any[]) => void) => void;
  $registerMountedQueue: (
    app: AppCollection,
    e: EventList,
    params: Record<string, any>,
    store: any,
  ) => void; // 将事件注册到子应用mount成功的的事件队列中
  $cleanMountedQueue: (app: AppCollection) => void; // 清空子应用mount事件队列
};

type Queue = {
  [app in AppCollection]?: any[];
};

export type PreviewMediaConfiguration = {
  type: "IMG" | "PDF";
  list: string[];
  index: number | undefined;
};

export type JumpDetailPageConfiguration = {
  type: "driver" | "vehicle";
  record: {
    id: string | number;
    tab: string;
    frameNumber?: string;
    type?: string;
  };
};

let instance: EventBusInstance | undefined = undefined;

export default () => {
  const queue: Queue = {};
  if (!instance) {
    instance = {
      $emit: (event, params) => bus.$emit(event, params),
      $on: (event, fn) => bus.$on(event, fn),
      $registerMountedQueue: (app, event, params, store) => {
        const isMounted = store.state.globalState.appMounted[app];
        const fn = () => bus.$emit(event, params );
        // 子应用已挂载完成可以直接通信
        if (isMounted) {
          fn();
          return;
        }
        if (queue[app] && queue[app]!.length) {
          queue[app]!.push(fn);
        } else {
          queue[app] = [fn];
        }
      },
      $cleanMountedQueue: (app) => {
        while (queue[app] && queue[app]!.length) {
          const fn = queue[app]!.shift();
          fn();
        }
      }
    };
  }

  return instance;
};
